import React, { useState } from 'react';
import logo from './../assets/logo.png';
import Link from './../components/Link';
import Heading from './../components/Heading';

const Navbar = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    return (
        <nav className="bg-gray-50 py-4 sm:py-0 mx-auto opacity-90 shadow-md">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-10 gap-8 items-center h-14 md:h-20">
                
                {/* Logo */}
                <div className="col-span-4 flex flex-row items-center justify-start space-x-2">
                    <img src={logo} alt="Logo" className="h-16 lg:h-20" />
                    <Heading tstyle="text-3xl whitespace-nowrap italic" name="Pocket LPO" />
                </div>

                
                {/* Menu items for larger screens */}
                <div className="col-span-6 hidden md:flex justify-center md:space-x-12 space-x-16">
                    <Link href="/" text="Home" tstyle='text-gray-900'/>
                    <Link href="/about" text="About Us" tstyle='text-gray-900'/>
                    <Link href="/services" text="Services" tstyle='text-gray-900'/>
                    <Link href="/pricing" text="Pricing" tstyle='text-gray-900'/>
                    <Link href="/faq" text="FAQs" tstyle='text-gray-900'/>
                    <Link href="/contact" text="Contact Us" tstyle='text-gray-900'/>
                </div>

                {/* Mobile menu button */}
                <div className="md:hidden col-span-6 flex justify-end">
                    <button
                        className="text-gray-500 focus:outline-none"
                        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                    >
                        <svg fill="currentColor" viewBox="0 0 20 20" className="w-6 h-6">
                            <path fillRule="evenodd" d="M3 5h14a1 1 0 110 2H3a1 1 0 110-2zm0 5h14a1 1 0 110 2H3a1 1 0 110-2zm0 5h14a1 1 0 110 2H3a1 1 0 110-2z" clipRule="evenodd"></path>
                        </svg>
                    </button>
                </div>
            </div>

            {/* Mobile menu items */}
            {isMobileMenuOpen && (
                <div className="md:hidden bg-white shadow-lg">
                    <div className="flex flex-col items-center space-y-4 py-8">
                        <Link href="/" text="Home" tstyle='text-gray-900'/>
                        <Link href="/" text="About Us" tstyle='text-gray-900'/>
                        <Link href="/services" text="Services" tstyle='text-gray-900'/>
                        <Link href="/pricing" text="Pricing" tstyle='text-gray-900'/>
                        <Link href="/faq" text="FAQs" tstyle='text-gray-900'/>
                        <Link href="/contact" text="Contact Us" tstyle='text-gray-900'/>
                    </div>
                </div>
            )}
        </nav>
    );
};

export default Navbar;
